import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight, Equalizer } from '@eqi-investimentos/icons/web';
import { Box, Input, Flex, Text, Skeleton } from '@eqi-investimentos/react';
import { useGetAssets } from '@/modules/Asset/http/client/useGetAssets';
import { useInvest } from '@/contexts/InvestContext';
import { useDebounce } from '@/hooks/useDebounce';
import { Icon } from '@/components/atoms/Icon';
import { Thumb } from '@/components/atoms/Thumb';
import { IfRender, MapRender } from '@/utils/jsx';
import { SelectAssetSectionSkeleton } from './Skeleton';
export const SelectAssetSection = () => {
  const {
    t
  } = useTranslation('common');
  const {
    selectAsset
  } = useInvest();
  const [searchParam, setSearchParam] = useState('');
  const debouncedSearchParam = useDebounce(searchParam);
  const {
    data: assets = [],
    status: assetsStatus
  } = useGetAssets({
    search: debouncedSearchParam,
    page: 1,
    limit: 15
  });
  const [assetToSearch, setAssetToSearch] = useState('');
  const loadingAssets = assetsStatus === 'pending';
  return <Box w="full" data-sentry-element="Box" data-sentry-component="SelectAssetSection" data-sentry-source-file="index.tsx">
      <Flex alignItems="center" w="full" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Input placeholder={t('screens.invest.selectAsset.searchPlaceholder')} type="text" value={assetToSearch} onChange={e => {
        setAssetToSearch(e.target.value);
        setSearchParam(() => e.target.value);
      }} rightIcon={<Icon iconName={assetToSearch.length === 0 ? 'Search' : 'Trash'} width={24} height={24} color="content.brand" onClick={() => {
        setAssetToSearch('');
        setSearchParam(() => '');
      }} />} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
      </Flex>
      <IfRender condition={loadingAssets} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <SelectAssetSectionSkeleton data-sentry-element="SelectAssetSectionSkeleton" data-sentry-source-file="index.tsx" />
      </IfRender>
      <IfRender condition={!loadingAssets} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <Box py="xl" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <IfRender condition={assets.length === 0} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
            <Flex alignItems="center" justifyContent="space-be" gap="5" w="22.375rem" h="5.625rem" px="4" py="3" bgColor="var(--color-eqi-white)" borderRadius="lg" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
              <Equalizer width={7} height={7} fill="var(--color-eqi-black)" data-sentry-element="Equalizer" data-sentry-source-file="index.tsx" />
              <Text fontWeight="bold" lineHeight="4" color="var(--color-eqi-gray)" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {t('screens.invest.selectAsset.noAssets')}
              </Text>
            </Flex>
          </IfRender>
          <IfRender condition={assets.length > 0} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
            <Flex flexDir="column" gap="xs" py="xl" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
              <MapRender items={assets} render={asset => <Flex flexDir="row" w="full" key={asset.id} justify="space-between" alignItems="center" py="s" px="xs" onClick={() => selectAsset({
              asset
            })} cursor="pointer" _hover={{
              background: 'background.brandLight',
              borderRadius: 'xs'
            }}>
                    <Flex gap="xs" flexDirection="row" w="full">
                      <Thumb src={asset.thumb || ''} width={32} height={32} fit="cover" alt={asset.title} />
                      <Text size="l" color="content.primary">
                        {asset.title}
                      </Text>
                    </Flex>
                    <Icon iconName="ChevronRight" w={24} h={24} color="content.brand" />
                  </Flex>} data-sentry-element="MapRender" data-sentry-source-file="index.tsx" />
            </Flex>
          </IfRender>
        </Box>
      </IfRender>
    </Box>;
};